<template>
  <b-overlay :show="isLoading" bg-color="transparent" blur="2px">
    <!-- LOADING OVERLAY -->
    <template #overlay>
      <img src="@/assets/lottie/plant.gif" style="width: 5em" />
    </template>
    <b-card no-body class="pt-5 rounded-xl mb-5">
      <!-- CARD HEADER -->
      <b-card-header
        class="border-2 border-bottom px-5 pt-0 pb-3 d-flex align-items-center"
        v-if="title"
      >
        <a
          v-if="!$store.state.unknownRoute && showBack"
          @click="$router.go(-1)"
          class="btn btn-transparent btn-lg btn-icon btn-back mr-1"
          v-b-tooltip.top="$t('global.go_back')"
        >
          <i class="ri-arrow-left-circle-line text-primary p-0"></i>
        </a>
        <b-card-title v-if="title" class="mb-0">
          {{ title }}
        </b-card-title>
        <div class="ml-auto"></div>
        <b-btn
          v-if="showEdit"
          class="py-2"
          size="sm"
          variant="light-warning"
          @click="$emit('onEdit')"
        >
          <i class="ri-edit-line"></i>
          Edit
        </b-btn>
        <b-btn
          v-if="showDelete"
          class="ml-2 py-2"
          size="sm"
          variant="light-danger"
          @click="$emit('onDelete')"
        >
          <i class="ri-delete-bin-line"></i>
          Hapus
        </b-btn>
      </b-card-header>
      <!-- CARD BODY -->
      <b-card-body class="pt-5 pb-0">
        <slot name="card-body">
          <!-- get from api component -->
          <div v-if="api">
            <b-table
              :fields="tempFields"
              :items="table.data"
              :per-page="table.perPage"
              :current-page="table.currentPage"
              @filtered="onTableFiltered"
            >
              <template v-for="(field, fIndex) in tempFields" v-slot:[`cell(${field.key})`]="{ item, index }">
                
                <span v-if="field.key === 'index'">
                  {{ index + (table.currentPage - 1) * table.perPage + 1 }}.
                </span>
                <!-- Editable Fields -->
                <span v-else-if="field.type == 'input'">
                  <s-input
                    v-if="submissionData[index]"
                    v-model="submissionData[index][field.key]"
                    :item="field.item"
                    @input="emitSubmissionData"
                    @change="emitSubmissionData"
                  />
                </span>

                <span v-else>
                  <slot
                    v-if="$scopedSlots[field.key]"
                    :name="field.key"
                    :rowData="item"
                  ></slot>
                  <template v-else>
                    <span :class="classReader(item[field.key], field.classes)">
                      <span v-if="field.transform">
                        {{ item[field.key] | parse(field.transform) }}
                      </span>
                      <span v-else>
                        {{ item[field.key] }}
                      </span>
                    </span>
                  </template>
                </span>
              </template>
            </b-table>
            <b-pagination
              v-if="!hidePagination"
              :total-rows="table.totalRows"
              :per-page="table.perPage"
              v-model="table.currentPage"
            ></b-pagination>
          </div>
          <div v-if="table.data.length > 0">
            <b-table
              :fields="tempFields"
              :items="table.data"
              :per-page="table.perPage"
              :current-page="table.currentPage"
              @filtered="onTableFiltered"
            >
              <template v-for="(field, fIndex) in tempFields" v-slot:[`cell(${field.key})`]="{ item, index }">
                
                <span v-if="field.key === 'index'">
                  {{ index + (table.currentPage - 1) * table.perPage + 1 }}.
                </span>
                <!-- Editable Fields -->
                <span v-else-if="field.type == 'input'">
                  <div v-show="!(field.item && field.item.option && field.item.option.isHide)">
                    <s-input
                      :ref="`polygonInput-${index}`"
                      v-if="submissionData[index]"
                      v-model="submissionData[index][field.key]"
                      :item="field.item"
                      @input="emitSubmissionData"
                      @change="emitSubmissionData"
                    />
                  </div>
                  <div v-if="(field.item && field.item.option && field.item.option.isHide)" class="polygon-preview">
                    <!-- {{ submissionData[index].polygon_preview ? <img src="@/assets/lottie/plant.gif" /> || 'No Preview Available ' }} -->
                    <img v-if="submissionData[index].polygon_preview" :src="submissionData[index].polygon_preview" />
                    <div v-else>
                      No Preview Available
                    </div>
                  </div>
                </span>
                <span v-else>
                  <slot
                    v-if="$scopedSlots[field.key]"
                    :name="field.key"
                    :rowData="item"
                  ></slot>
                  <template v-else>
                    <span :class="classReader(item[field.key], field.classes)">
                      <span v-if="field.transform">
                        {{ item[field.key] | parse(field.transform) }}
                      </span>
                      <span v-else>
                        {{ item[field.key] }}
                      </span>
                    </span>
                  </template>
                </span>
              </template>
            </b-table>
            <b-pagination
              v-if="!hidePagination"
              :total-rows="table.totalRows"
              :per-page="table.perPage"
              v-model="table.currentPage"
            ></b-pagination>
          </div>
        </slot>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import { autoReplaceWithKml } from "@/utils/polygon-handler/autoReplaceWithKml";

export default {
  name: "GrowerSimpleSubmitionTable",

  props: {
    title: {
      type: String,
      default: "",
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    fields: {
      type: Array,
      default: () => [],
    },
    api: {
      type: String,
      default: "",
    },
    apiParams: {
      type: Object,
      default: () => ({}),
    },
    hideIndex: {
      type: Boolean,
      default: false,
    },
    hidePagination: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    tempFields() {
      const newFields = [];

      // Add index column safely
      if (this.api && !this.hideIndex) {
        newFields.push({
          label: "No",
          key: "index",
          thStyle: { width: "60px", textAlign: "center" },
          tdClass: "text-center",
          thClass: "",
          class: "",
        });
      }

      if (Array.isArray(this.fields)) {
        this.fields.forEach((f, i) => {
          if (!f || typeof f !== "object") return;

          newFields.push({
            label: f.label || f.key || `Kolom ${i + 1}`,
            key: f.key || `col_${i}`,
            type: f.type || null,
            options: Array.isArray(f.options) ? f.options : [],
            item: f.item || {},
            disabled: f.disabled || false,
            thStyle: f.thStyle || {},
            tdStyle: f.tdStyle || {},
            thClass: typeof f.thClass === "string" || Array.isArray(f.thClass) ? f.thClass : "",
            tdClass: typeof f.tdClass === "string" || Array.isArray(f.tdClass) ? f.tdClass : "",
            class: typeof f.class === "string" || Array.isArray(f.class) ? f.class : "",
            transform: f.transform || null,
            classes: f.classes || null,
            default_value: f.default_value,
          });
        });
      }

      return newFields;
    },
  },


  watch: {
    data: {
      immediate: true,
      deep: false,

      handler(val) {
        if (
          !this.api &&
          Array.isArray(val.data) &&
          this.submissionData.length === 0
        ) {
          this.table.data = val.data;
          this.table.totalRows = val.data.length;

          this.submissionData =
            val.data.map(row => ({
              ...row
            }));
        }
      }
    }
  },

  data() {
    return {
      isLoading: false,
      mainData: {},
      table: {
        data: [],
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
      },
      submissionData: [],
    };
  },

  mounted() {
    if (this.api) {
      this.getData();
    }
  },

  methods: {
    
    classReader(value, classes) {
      if (classes instanceof Object) {
        if (value instanceof Array) {
          value.forEach((val) => {
            return classes[val];
          });
        } else return classes[value];
      } else return classes;
    },
    async getData() {
      try {
        this.isLoading = true;
        const res = await this.$_api.get(this.api, this.apiParams);
        console.log("response getData()", res)
        this.table.data = Array.isArray(res.data) ? res.data : [];
        this.table.totalRows = this.table.data.length;

        this.submissionData = this.table.data.map(row => {
          const copy = { ...row }
          this.fields.forEach(f => {
            if (f.default_value !== undefined && f.default_value !== null && (copy[f.key] === undefined || copy[f.key] === null || copy[f.key] === '')) {
              copy[f.key] = f.default_value
            }
          })
          return copy
        })
      } catch (err) {
        console.log("getData() error", err);
        this.$_alert.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    emitSubmissionData() {
      this.$emit("onSubmissionChange", this.submissionData);
    },
    onTableFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.table.totalRows = filteredItems.length;
      this.table.currentPage = 1;
    },
    async autoInputKMLForRow(rowIndex, base64Data, filename) {
      try {
        if (!this.submissionData[rowIndex]) return;
        const file = this.base64ToFile(base64Data, filename);
        const tableRows = this.$el.querySelectorAll('tbody tr');
        if (!tableRows || !tableRows[rowIndex]) {
          console.warn('autoInputKMLForRow: row not found', rowIndex);
          return;
        }

        const fileInput = tableRows[rowIndex].querySelector('input[type="file"]');
        if (!fileInput) {
          console.warn('autoInputKMLForRow: file input not found in row', rowIndex);
          return;
        }

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        fileInput.files = dataTransfer.files;

        const event = new Event('change', { bubbles: true });
        fileInput.dispatchEvent(event);
        console.log(
          "submissionData row",
          this.submissionData[rowIndex]
        );
        console.log('autoInputKMLForRow() complete at index', rowIndex, filename)
      } catch (err) {
        console.error('autoInputKMLForRow() failed:', err);
      }
    },
    async autoReplaceKMLForRow(rowIndex, base64, filename) {
      let inputRef = this.$refs[`polygonInput-${rowIndex}`];
      if (Array.isArray(inputRef)) {
        inputRef = inputRef[0];
      }
      if (!inputRef) {
        console.warn("polygon input ref not found",rowIndex);
        return;
      }
      autoReplaceWithKml({
        vm: {$refs: {tempInput: inputRef}},
        inputRef: "tempInput",
        base64,
        filename
      });
    },
    base64ToFile(base64String, filename) {
      const arr = base64String.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },

  },
};
</script>

<style scoped>
.table-detail tr:first-child td {
  border-top: none !important;
}
.img-table {
  height: 150px;
  width: 150px;
  border-radius: 8px;
  object-fit: cover;
  cursor: pointer;
  margin-right: 1rem;
}
.polygon-preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

.polygon-preview img {
  width: 100px;
  height: 100px;

  border: 1px solid #ddd;
  border-radius: 8px;

  background: #fff;

  object-fit: contain;
}

</style>



// WEBPACK FOOTER //
// src/base/component/simple-submission-table.vue